var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "add-address-modal",
        autofocus: _vm.$refs.address,
        successHandler: _vm.handleCreate,
        title: _vm.$t("add_address")
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c("address-input", {
        ref: "address",
        attrs: { slot: "content", expanded: "", required: "" },
        slot: "content",
        model: {
          value: _vm.formData.address,
          callback: function($$v) {
            _vm.$set(_vm.formData, "address", $$v)
          },
          expression: "formData.address"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }